import React from 'react';
import { Field, formValueSelector, reduxForm, change } from 'redux-form';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';

import SettingField from 'components/Fields/ReduxForm/SettingField';

const FORM_NAME = 'itemHub';

class ItemVariantsFields extends React.Component {
  render() {
    const { member, index, fields } = this.props;
    const isHide =
      fields.length === 1 &&
      (fields.get(index).name === undefined || fields.get(index).name === '');

    const priceContainClassName = classNames('form-group', {
      'col-md-6': isHide,
      'col-md-4': !isHide,
      'no-padding': !isHide,
    });
    const skuContainClassName = classNames('form-group', {
      'col-md-6': isHide,
      'col-md-4': !isHide,
    });

    return (
      <div className="mk-grouped-input">
        {!isHide && (
          <div className={`form-group col-md-4`}>
            <Field
              name={`${member}.name`}
              component={SettingField}
              className="form-control"
              placeholder="Name"
            />
          </div>
        )}
        <div className={priceContainClassName}>
          <Field
            name={`${member}.price`}
            component={SettingField}
            maxLength={11}
            placeholder="Price"
            inputClassName="text-right"
            positiveNumberOnly
            onBlur={this._handleChangePriceVariant}
          />
        </div>
        <div className={skuContainClassName}>
          <Field
            name={`${member}.sku`}
            component="input"
            className="form-control text-align-last-left"
            placeholder="SKU"
          />
        </div>
      </div>
    );
  }

  _handleChangePriceVariant = () => {
    const { dispatch, itemVariants, itemOutlets } = this.props;
    itemOutlets.forEach((itemOutlet, idx) => {
      if (!itemOutlet.is_custom_price) {
        itemOutlet.item_variant_custom_outlet_prices = itemVariants;
        dispatch(change(FORM_NAME, `item_outlets[${idx}]`, itemOutlet));
      }
    });
  };
}

const mapForm = {
  form: FORM_NAME,
  destroyOnUnmount: false,
  touchOnBlur: false,
};

const selector = formValueSelector(FORM_NAME);

function mapStateToProps(state) {
  return {
    itemOutlets: selector(state, 'item_outlets'),
    itemVariants: selector(state, 'item_variants'),
  };
}

export default connect(mapStateToProps)(reduxForm(mapForm)(ItemVariantsFields));
